import { styled } from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const Wrapper = styled(Stack)`
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0 3px 6px ${rgba(colorsPalettes.carbon[500], 0.08)};
    border-radius: 6px;
`;

export const ChartWrapper = styled(Stack)`
    width: 29%;
    justify-content: center;
    align-items: center;
    padding-top: 8px;
`;

export const TableWrapper = styled(Flex)`
    width: 71%;
    align-items: center;
`;

export const LegendWrapper = styled.div`
    width: 100%;
`;

export const LoaderWrapper = styled(Flex)`
    height: 232px;
    align-items: center;
`;
